const REGEX = {
  DIGIT: /\d/g
};

export default REGEX;
